
import { useNavigate } from 'react-router-dom';

import '../styles/EmployeeMaster.css';
import RosterTable from '../components/RosterTable';

const Roster = () => {
  const navigate = useNavigate();

  const handleAddClick = () => {
    
    navigate('/roster/add');
  };

  

  return (
    <div className="employee-master-page">
      <div className="employee-header">
        <h2>Roster Master</h2>
        <button className="add-employee-btn" onClick={handleAddClick}>
          Add Roster
        </button>
      </div>

      <RosterTable />
    </div>
  );
};

export default Roster;